import { render, staticRenderFns } from "./AdminNovi.vue?vue&type=template&id=680c539d&scoped=true&"
import script from "./AdminNovi.vue?vue&type=script&lang=js&"
export * from "./AdminNovi.vue?vue&type=script&lang=js&"
import style0 from "./AdminNovi.vue?vue&type=style&index=0&id=680c539d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c539d",
  null
  
)

export default component.exports